var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex justify-content-between"
  }, _vm._l(_vm.tabs, function (tab, index) {
    return _c('div', {
      key: index,
      staticClass: "w-100"
    }, [_c('div', {
      staticClass: "d-flex align-items-center w-100"
    }, [_c('div', {
      staticClass: "tab-number border cursor-pointer",
      class: {
        'bg-primary': _vm.activeTab == index + 1
      },
      on: {
        "click": function click($event) {
          return _vm.handleClick(tab.id);
        }
      }
    }, [_vm._v(" " + _vm._s(tab.id) + " ")]), _c('div', {
      staticClass: "line-tab w-100",
      class: {
        'border-active': _vm.activeTab == index + 1
      }
    })]), _c('h6', {
      class: {
        'text-primary': _vm.activeTab == index + 1,
        'text-secondary': _vm.activeTab != index + 1
      }
    }, [_vm._v(_vm._s(tab.label))])]);
  }), 0);

}
var staticRenderFns = []

export { render, staticRenderFns }